import React from 'react';
import Axios from 'axios';

class AddSeason extends React.Component {

  constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	render() {
		//console.log('AddSeason: render');
		return (
			<div className="row">
      <div className="col-md-12">
      <form className="form-horizontal" onSubmit={this.handleSubmit}>

        <div className="row">
        <div className="col-md-10">
          <div className="form-group">
	        <h5>Ajout d'une saison</h5>
					Nom <br/>
					
        	<div className="row">
					<div className="col-md-8">
						<input type="text" className="form-control" id="seasonName" placeholder="Nom de la Saison (ex: AH-2016)"/>
						<br/>
						<button type="submit" className="btn btn-primary">Ajouter la saison</button>
					</div>
					</div>
					</div>

				</div>
				</div>

			</form>
			</div>
 			</div>
    );
  }

	handleSubmit(e) {
		var _this = this;
		e.preventDefault();

		Axios.post('/api/seasons/', {
			seasonName: e.target.elements[0].value,		// verifier ce code, event, target, elements, etc
			leagueObjId: _this.props.lgid
		})
		.then(function(response) {
			//console.log(response);
			const path = '/admsafe/league';
			_this.props.history.push(path);

			// Call parent function
			_this.props.reloadLeagues();

		})
		.catch(function(error) {
			console.log(error);
		});
	}

}

export default AddSeason;